// Flow types automatically removed

import { Fragment } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader.tsx';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { Link } from 'dibs-elements/exports/Link.tsx';
import styles from './styles/FormConfirmation.scss';
export const FormConfirmation = () => (
    <Fragment>
        <BarHeader
            title={
                <FormattedMessage
                    id="abt.matchmaker.formStepConfirmation.title"
                    defaultMessage="We’ve received your Designer Connection request!"
                />
            }
        />
        <div className={styles.explanation}>
            <p>
                <FormattedMessage
                    id="abt.matchmaker.formStepConfirmation.explanation"
                    defaultMessage="Our Designer Connection team will reach out to you soon to learn more about your project so we can select top designers for you based on your style, budget and design needs."
                />
            </p>
            <p>
                <FormattedMessage
                    id="abt.matchmaker.formStepConfirmation.meanTime"
                    defaultMessage="In the meantime, take a look at inspiring interiors to get ideas for your own space."
                />
            </p>
        </div>
        <div className={styles.contentWrapper}>
            <div className={styles.images}>
                <div className={styles.image1} />
                <div className={styles.image2} />
                <div className={styles.image3} />
            </div>
            <div className={styles.ctaContainer}>
                <Button href="/interiors/" dataTn="view-interiors-cta">
                    <FormattedMessage
                        id="abt.matchmaker.formStepConfirmation.buttonText"
                        defaultMessage="View Interiors"
                    />
                </Button>
            </div>
            <Link href="/furniture/" className={styles.linkText} dataTn="browse-items-cta">
                <FormattedMessage
                    id="abt.matchmaker.formStepConfirmation.browsePieces"
                    defaultMessage="Or, browse pieces for your next project"
                />
            </Link>
        </div>
    </Fragment>
);
